import React from "react";
import classes from "../TrucksAvailable.module.css";

const DEFAULT_SORT_OPTIONS = [{ value: "created_date", label: "Created Date" }];

const ActiveFiltersPills = ({
  isFilterActive,
  currentFilterPayload,
  handleFilterApply,
  handleFilterReset,
  setEnquiryBucket,
  setuserview,
  setEnquiryLevel,
  enquiryLevel,
}) => {
  if (!isFilterActive || !currentFilterPayload) return null;

  const hasFilters =
    currentFilterPayload.filters && currentFilterPayload.filters.length > 0;
  const hasSearch =
    currentFilterPayload.search && currentFilterPayload.search.trim() !== "";
  const currentSortKey = currentFilterPayload.sort?.key;
  const isDefaultSort = currentSortKey === "created_date" || !currentSortKey;
  const currentSortLabel =
    DEFAULT_SORT_OPTIONS.find((o) => o.value === currentSortKey)?.label ||
    currentSortKey;
  const hasSort = !isDefaultSort;

  const currentLimit = currentFilterPayload.pagination?.limit;
  const hasPagination =
    currentLimit && (currentLimit === 20 || currentLimit === 50);

  const hasBucket =
    currentFilterPayload.bucket && currentFilterPayload.bucket !== "active";
  const hasView =
    currentFilterPayload.view && currentFilterPayload.view !== "user_view";

  if (
    !hasFilters &&
    !hasSearch &&
    !hasSort &&
    !hasBucket &&
    !hasView &&
    !hasPagination
  )
    return null;

  const removeFilter = (filterKey) => {
    const updatedFilters = currentFilterPayload.filters.filter(
      (f) => f.key !== filterKey
    );
    const updatedPayload = {
      ...currentFilterPayload,
      filters: updatedFilters,
      pagination: { ...currentFilterPayload.pagination, skip: 0 },
    };

    if (
      updatedFilters.length === 0 &&
      (!currentFilterPayload.search ||
        currentFilterPayload.search.trim() === "") &&
      isDefaultSort &&
      (!hasBucket || currentFilterPayload.bucket === "active") &&
      (!hasView || currentFilterPayload.view === "user_view")
    ) {
      handleFilterReset();
    } else {
      handleFilterApply(updatedPayload);
    }
  };

  const clearSearch = () => {
    const updatedPayload = {
      ...currentFilterPayload,
      search: "",
      pagination: { ...currentFilterPayload.pagination, skip: 0 },
    };

    if (
      (!updatedPayload.filters || updatedPayload.filters.length === 0) &&
      isDefaultSort &&
      (!hasBucket || currentFilterPayload.bucket === "active") &&
      (!hasView || currentFilterPayload.view === "user_view")
    ) {
      handleFilterReset();
    } else {
      handleFilterApply(updatedPayload);
    }
  };

  const resetSort = () => {
    const updatedPayload = {
      ...currentFilterPayload,
      sort: { key: "created_date", order: "desc" },
      pagination: { ...currentFilterPayload.pagination, skip: 0 },
    };

    if (
      (!updatedPayload.filters || updatedPayload.filters.length === 0) &&
      (!updatedPayload.search || updatedPayload.search.trim() === "") &&
      (!hasBucket || currentFilterPayload.bucket === "active") &&
      (!hasView || currentFilterPayload.view === "user_view")
    ) {
      handleFilterReset();
    } else {
      handleFilterApply(updatedPayload);
    }
  };

  const resetBucket = () => {
    setEnquiryBucket("active");
    const updatedPayload = {
      ...currentFilterPayload,
      bucket: "active",
      isBucketExplicitlySet: false,
    };

    if (
      (!updatedPayload.filters || updatedPayload.filters.length === 0) &&
      (!updatedPayload.search || updatedPayload.search.trim() === "") &&
      isDefaultSort &&
      (!hasView || updatedPayload.view === "user_view")
    ) {
      handleFilterReset();
    } else {
      handleFilterApply(updatedPayload);
    }
  };

  const resetView = () => {
    setuserview(true);
    setEnquiryLevel("user_view");
    const updatedPayload = {
      ...currentFilterPayload,
      view: "user_view",
    };

    if (
      (!updatedPayload.filters || updatedPayload.filters.length === 0) &&
      (!updatedPayload.search || updatedPayload.search.trim() === "") &&
      isDefaultSort &&
      (!hasBucket || currentFilterPayload.bucket === "active")
    ) {
      handleFilterReset();
    } else {
      handleFilterApply(updatedPayload);
    }
  };

  const resetPagination = () => {
    const updatedPayload = {
      ...currentFilterPayload,
      pagination: { ...currentFilterPayload.pagination, limit: 10, skip: 0 },
    };

    if (
      (!updatedPayload.filters || updatedPayload.filters.length === 0) &&
      (!updatedPayload.search || updatedPayload.search.trim() === "") &&
      isDefaultSort &&
      (!hasBucket || currentFilterPayload.bucket === "active") &&
      (!hasView || currentFilterPayload.view === "user_view")
    ) {
      handleFilterReset();
    } else {
      handleFilterApply(updatedPayload);
    }
  };

  const getBucketLabel = (val) => {
    switch (val) {
      case "active":
        return "Active";
      case "cancelled":
        return "Cancelled";
      case "expired":
      case "archived":
        return "Archived";
      case "approved":
        return "Approved";
      case "all":
        return "All";
      default:
        return val;
    }
  };

  const getViewLabel = (val) => {
    switch (val) {
      case "user_view":
        return "My Enquiries";
      case "company_view":
        return "Company Enquiries";
      default:
        return val;
    }
  };

  const formatValue = (value) => {
    if (Array.isArray(value)) return value.join(", ");
    return value;
  };

  return (
    <div className={classes.activeFiltersArea}>
      <div className={classes.filterHeader}>
        <i className="fa fa-filter mr-2 text-primary" />
        <span className={classes.filterHeaderLabel}>Active Filters</span>
      </div>

      <div className={classes.filterPillsContainer}>
        {hasView && (
          <div className={classes.filterPill}>
            <i
              className="fa fa-eye mr-2 text-primary"
              style={{ fontSize: "12px" }}
            />
            <span className={classes.filterPillTitle}>View:</span>{" "}
            <span className={classes.filterPillValue}>
              {getViewLabel(currentFilterPayload.view)}
            </span>
            <i
              className={`fa fa-times-circle ${classes.filterRemoveBtn}`}
              onClick={resetView}
            />
          </div>
        )}

        {hasBucket && (
          <div className={classes.filterPill}>
            <i
              className="fa fa-bitbucket mr-2 text-warning"
              style={{ fontSize: "12px" }}
            />
            <span className={classes.filterPillTitle}>Bucket:</span>{" "}
            <span className={classes.filterPillValue}>
              {getBucketLabel(currentFilterPayload.bucket)}
            </span>
            <i
              className={`fa fa-times-circle ${classes.filterRemoveBtn}`}
              onClick={resetBucket}
            />
          </div>
        )}

        {hasSearch && (
          <div className={classes.filterPill}>
            <i
              className="fa fa-search mr-2 text-info"
              style={{ fontSize: "12px" }}
            />
            <span className={classes.filterPillTitle}>Search:</span>{" "}
            <span className={classes.filterPillValue}>
              {currentFilterPayload.search}
            </span>
            <i
              className={`fa fa-times-circle ${classes.filterRemoveBtn}`}
              onClick={clearSearch}
            />
          </div>
        )}

        {currentFilterPayload.filters
          ?.filter((f) => f.key !== "bucket" && f.key !== "view")
          ?.map((f, i) => (
            <div key={`${f.key}_${i}`} className={classes.filterPill}>
              <i
                className="fa fa-check-circle mr-2 text-success"
                style={{ fontSize: "12px" }}
              />
              <span className={classes.filterPillTitle}>
                {f.label || f.key}:
              </span>{" "}
              <span className={classes.filterPillValue}>
                {formatValue(f.values)}
              </span>
              <i
                className={`fa fa-times-circle ${classes.filterRemoveBtn}`}
                onClick={() => removeFilter(f.key)}
              />
            </div>
          ))}

        {hasSort && (
          <div className={classes.filterPill}>
            <i
              className="fa fa-sort mr-2 text-warning"
              style={{ fontSize: "12px" }}
            />
            <span className={classes.filterPillTitle}>Sort:</span>{" "}
            <span className={classes.filterPillValue}>{currentSortLabel}</span>
            <i
              className={`fa fa-times-circle ${classes.filterRemoveBtn}`}
              onClick={resetSort}
            />
          </div>
        )}

        {hasPagination && (
          <div className={classes.filterPill}>
            <i
              className="fa fa-list-ol mr-2 text-secondary"
              style={{ fontSize: "12px" }}
            />
            <span className={classes.filterPillTitle}>Limit:</span>{" "}
            <span className={classes.filterPillValue}>{currentLimit}</span>
            <i
              className={`fa fa-times-circle ${classes.filterRemoveBtn}`}
              onClick={resetPagination}
            />
          </div>
        )}
      </div>

      <button className={classes.clearAllBtn} onClick={handleFilterReset}>
        Clear All
      </button>
    </div>
  );
};

export default ActiveFiltersPills;
